import { useStore } from "react-admin";
import { useCallback, useMemo } from "react";
import { useValueRange } from "./use-value-range";
import { useColorScheme } from "./use-color-scheme";
import { colorByColorScheme } from "../models/color";
import { getColorGradient } from "../models/color-scheme";

export const useColor = (): [(value: number) => string, string, string, boolean] => {
  const colorScheme = useColorScheme();
  const [colorSchemeReverse] = useStore('map.imageColorSchemeReverse', false);
  const [dataMin, dataMax] = useValueRange();

  const getColorByValue = useCallback((value: number) => {
    return colorByColorScheme(dataMin, dataMax, value, colorScheme?.colors, colorSchemeReverse);
  }, [colorScheme, dataMin, dataMax, colorSchemeReverse]);

  const colorMin = useMemo(() => {
    return colorByColorScheme(0, 100, 0, colorScheme?.colors, colorSchemeReverse);
  }, [colorScheme, dataMin, dataMax, colorSchemeReverse]);

  const colorMax = useMemo(() => {
    return colorByColorScheme(0, 100.0, 100.0, colorScheme?.colors, colorSchemeReverse);
  }, [colorScheme, dataMin, dataMax, colorSchemeReverse]);

  return [getColorByValue, colorMin, colorMax, colorSchemeReverse];
};

export const useColorGradient = (): [string] => {
  const colorScheme = useColorScheme();
  const [colorSchemeReverse] = useStore('map.imageColorSchemeReverse', false);
  return [getColorGradient(colorScheme, colorSchemeReverse)];
};